// extracted by mini-css-extract-plugin
module.exports = {"svg":"arrow-module__svg___zXyeA","arrow":"arrow-module__arrow___1B8zA","stem":"arrow-module__stem___1R3-E","connect":"arrow-module__connect___bzcHI"};